import React from 'react';

import './Message.css';
import "../../styles/font-awesome-4.7.0/css/font-awesome.min.css";
 
const Message = (props) => (
  <div
    // className="mn-message__doc--primary  success   warning   danger"
    className={`mn-message__doc--${props.mode}`}
  >
    {props.title && <span>{props.title + ":"}</span>}
    <ul>
      {props.messages.map((message, index) => {
        return <li key={index}>{message}</li>;
      })}
    </ul>
  </div>
);

export default Message;

